import React, { useEffect, useState } from 'react';
import { useStyles } from './Style';
import { Typography, Grid, Card, CardContent } from '@mui/material';
import { InputV2, ButtonLoading, LoadingPage } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import ChangeUsernameServices from './services/ChangeUsernameServices';
import createToast from 'components/Toast/Toast';

const ChangeUsername = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);

  const [user, setUser] = useState(null);

  // -- HOOKS --//
  const classes = useStyles();

  const methods = useForm();
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    getUser();
  }, []);

  //
  // -- APIS --//
  const getUser = async (body) => {
    setIsLoading(true);
    try {
      const r = await ChangeUsernameServices.getUser();
      setUser(r?.result);
      reset({ preferredUsername: r?.result?.preferred_username });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const changeUsername = async (data) => {
    if (data?.preferredUsername == user?.preferred_username) {
      createToast('خطا', 'نام کاربری وارد شده، همان نام کاربری فعلی شماست!', 'danger');
      return;
    }

    setIsSubmiting(true);

    try {
      const body = {
        username: data?.preferredUsername,
      };

      await ChangeUsernameServices.putUser(body);
      createToast('موفق', 'نام کاربری با موفقیت تغییر یافت.', 'success');

      setIsSubmiting(false);
    } catch (error) {
      setIsSubmiting(false);
    }
  };

  return (
    <div>
      <Card className={classes.helpCard}>
        <CardContent className={classes.helpContent}>
          <Typography className={classes.helpTextTitle} color="textSecondary">
            نکته قابل توجه
          </Typography>
          <Typography className={classes.helpTextBody} color="textSecondary">
            ویرایش نام کاربری موارد زیر را به همراه دارد :
            <br />
            <div className={classes.helpBodyItems}>
              ۱- از تمام دستگاه های لاگین شده خارج خواهید شد.
              <br />
              ۲- ایمیل سیستمی شما تغییر خواهد کرد.
            </div>
          </Typography>
        </CardContent>
      </Card>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(changeUsername)} noValidate autoComplete="off">
            <Grid container spacing={1}>
              <Grid item xs={12} md={4} lg={3}>
                <InputV2
                  errors={methods.formState.errors}
                  name="preferredUsername"
                  dir="ltr"
                  label="نام کاربری"
                  register={methods.register}
                  rules={['required', 'isUsername']}
                  fullWidth
                  control={methods.control}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12} className={classes.submitContainer} justifyContent="flex-end">
              <ButtonLoading
                type="submit"
                variant="contained"
                color="primary"
                loading={isSubmiting}
                name="تغییر نام کاربری"
              />
            </Grid>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default ChangeUsername;
